<div class="item-price" [class.isMobile]="isMobile">
  <div class="box-left">
    <div class="hotelRoomPrice__box-info">
      <app-ds-icon
        [icon]="boardIcon"
        [size]="16"
        [color]="iconFillColor.Secondary">
      </app-ds-icon>
      <app-ds-typography
        [size]="fontSize.XXXS"
        [fontFamily]="fontFamily.Regular"
        [color]="fontColor.Secondary"
        [text]="boardRoomDescription | capitalize">
      </app-ds-typography>
    </div>
    <ng-container *ngIf="isByhours">
      <div class="hotelRoomPrice__box-info">
        <app-ds-icon
          [icon]="icons.Clock"
          [size]="16"
          [color]="iconFillColor.Secondary">
        </app-ds-icon>
        <app-ds-typography
          [size]="fontSize.XXXS"
          [fontFamily]="fontFamily.Regular"
          [color]="fontColor.Secondary"
          [text]="'HOTELS_MODULE.DETAIL_DESCRIPTION.ABBREVIATION_HOURS'| transloco: { hours: hourType }">
        </app-ds-typography>
      </div>
    </ng-container>
    <ng-container *ngIf="isRefundable(roomRate.RefundableInfo);else nonRefundable">
      <div class="hotelRoomPrice__box-info">
        <app-ds-icon
          [icon]="icons.Check"
          [size]="16"
          [color]="iconFillColor.Success">
        </app-ds-icon>
        <app-ds-typography
          [size]="fontSize.XXXS"
          [fontFamily]="fontFamily.Regular"
          [color]="fontColor.Success"
          [text]="'HOTELS_MODULE.DETAIL_DESCRIPTION.REFUNDABLE_TEXT'| transloco">
        </app-ds-typography>
      </div>
    </ng-container>
    <ng-template #nonRefundable>
      <div class="hotelRoomPrice__box-info">
        <app-ds-icon
          [icon]="icons.Close"
          [size]="16"
          [color]="iconFillColor.Error">
        </app-ds-icon>
        <app-ds-typography
          [size]="fontSize.XXXS"
          [fontFamily]="fontFamily.Regular"
          [color]="fontColor.Error"
          [text]="'HOTELS_MODULE.DETAIL_DESCRIPTION.NON_REFUNDABLE_TEXT'| transloco">
        </app-ds-typography>
      </div>
    </ng-template>
    <div *ngIf="room?.PromotionalText" class="promotional">
      <app-ds-typography
        [size]="fontSize.Minor"
        [fontFamily]="fontFamily.Regular"
        [color]="fontColor.Secondary"
        [text]="('HOTELS_MODULE.DETAIL_DESCRIPTION.LABEL_PROMOTIONAL_TEXT'| transloco) + ' ' + room?.PromotionalText">
      </app-ds-typography>
    </div>
  </div>
  <div class="box-right">
    <app-member-rate-tag [tagType]="tagType"></app-member-rate-tag>
    <ng-container *ngIf="!!roomRate?.Price">
      <app-hotel-rate-discount
        [translateKey]="'HOTELS_MODULE.RESULT_HOTELS.OFF'"
        [translateProp]="'percentage'"
        [room]="roomRate"
        [htmlFormatByCurrency]="true">
      </app-hotel-rate-discount>
      <app-ds-typography
        [size]="fontSize.XS"
        [color]="fontColor.Primary"
        [fontFamily]="fontFamily.SemiBold"
        [text]="roomRate?.Price?.Total | currencyFormat: roomRate?.Price.CurrencyCode : true">
      </app-ds-typography>
    </ng-container>
    <p *ngIf="isPackageDetail" class="package-label">{{'HOTELS_MODULE.RESULT_HOTELS.PACKAGE_LABEL'| transloco}}</p>
    <ng-container *ngIf="isOneNight; else multipleNights">
      <p class="nights">{{'HOTELS_MODULE.RESULT_HOTELS.ROOMS_FOR_NIGHT'| transloco: { rooms: numberRooms }  }}</p>
    </ng-container>
    <div class="hotelRoomPrice__btn-ds">
      <app-ds-button
        [labels]="{ ButtonLabel: 'BUTTONS.SELECT' | transloco }"
        [isLoading]="isLoading"
        [size]="buttonSize"
        (clickEvent)="clickEvent(roomRate.RateId)">
      </app-ds-button>
    </div>
  </div>
</div>

<ng-template #multipleNights>
  <ng-container *ngIf="!isByhours; else isByhourLabel">
    <p class="nights">{{'HOTELS_MODULE.RESULT_HOTELS.ROOMS_FOR_NIGHTS'| transloco: { quantity: nights, rooms: numberRooms } }}</p>
  </ng-container>
  <ng-template #isByhourLabel>
    <p class="nights">{{'HOTELS_MODULE.RESULT_HOTELS.ROOMS_FOR_HOUR'| transloco: { quantity: hourType, rooms: numberRooms } }}</p>
    <p class="nights">{{'HOTELS_MODULE.RESULT_HOTELS.CAPACITY_BYHOURS'| transloco: { capacity: capacity } }}</p>
  </ng-template>
</ng-template>

<app-swipe-up
  [height]="85"
  [showSwipeUp]="showHoursSwipe"
  [title]="'HOTELS_MODULE.DETAIL_DESCRIPTION.CHECK_IN_TIMES'| transloco"
  [showHeader]="true"
  (toggleShowSwipeUp)="toogleShowHours()">
  <ng-container content *ngIf="showHoursSwipe">
    <div class="timeSelector_swipeCont">
      <app-by-hour-time-selector
        [roomRate]="roomRate"
        [selectedValue]="selectedTime"
        (selected)="selectTime($event)">
      </app-by-hour-time-selector>
      <app-fixed-surface
        [boxShadow]="true">
        <app-ds-button 
          [labels]="{ ButtonLabel: 'BUTTONS.APPLY' | transloco }"
          (click)="applyTime(roomRate.RateId)">
        </app-ds-button>
      </app-fixed-surface>
    </div>
  </ng-container>
</app-swipe-up>
